class Spinner extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="spinner">
          Spinner
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-spinner" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
          <Collapser>
            <div className="demo">
              <h4 className="demo__title">Caret Up</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                    &lt;div class="spinner"&gt;&lt;/div&gt;
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.spinner-demo {
  @include spinner($pure-black);
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="spinner-demo"></div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};

